export const HELP_NOTION_LINKS = {
  ROOT: 'https://opthub.notion.site/Mathlog-1ca318bcf9ac8129af6bc379e036b281',
  SIGN_UP: 'https://opthub.notion.site/1ca318bcf9ac81c58ca5fb4112acb027',
  LOGIN: 'https://opthub.notion.site/1ca318bcf9ac81e68a78e33151a9c1c6',
  PROFILE_SETTING:
    'https://opthub.notion.site/1ca318bcf9ac813b93e3e67cbc528eb4',
  ACCOUNT_SETTING:
    'https://opthub.notion.site/1ca318bcf9ac81c28aecdfa7f9fdc406',
  SEARCH_CONTENT: 'https://opthub.notion.site/1ca318bcf9ac812d866debbefc967fba',
  TIMELINE: 'https://opthub.notion.site/1ca318bcf9ac81fcbb21f163031694c2',
  RANKING: 'https://opthub.notion.site/1ca318bcf9ac810e8913cc5cf3b577d4',
  FOLLOW_FUNCTION:
    'https://opthub.notion.site/1ca318bcf9ac81b9b673e714a19a7107',
  LIKE_FUNCTION: 'https://opthub.notion.site/1ca318bcf9ac812799c7c7042b83d3d6',
  BOOKMARK_FUNCTION:
    'https://opthub.notion.site/1ca318bcf9ac817ba89cf4352cf15e59',
  COMMENT_FUNCTION:
    'https://opthub.notion.site/1ca318bcf9ac81a3b161d2be7975ad2e',
  SUPPORT_FOR_CREATORS:
    'https://opthub.notion.site/1ca318bcf9ac81dcbccdf12466f27602',
  MUTE_FUNCTION: 'https://opthub.notion.site/1ca318bcf9ac81cf85d7d0f14e666531',
  CONTENT_REPORTING:
    'https://opthub.notion.site/1ca318bcf9ac8151b5e7e7717161e665',
  EDITOR_USAGE: 'https://opthub.notion.site/1ca318bcf9ac8195ad0af2a1ae8319e0',
  ARTICLE_WRITING:
    'https://opthub.notion.site/1ca318bcf9ac816baaa7cc35d94a1dba',
  BOOK_WRITING: 'https://opthub.notion.site/1ca318bcf9ac81e09a4ae6aa1a33f9c0',
  REFERENCES_SETTING:
    'https://opthub.notion.site/1ca318bcf9ac81a9b76cfd0068726cd2',
  MACROS_SETTING: 'https://opthub.notion.site/1ca318bcf9ac81eba46fff47643193d8',
  PACKAGES_SETTING:
    'https://opthub.notion.site/1ca318bcf9ac81a5af8acfe0cb97049f',
  LATEX_EXPORT:
    'https://opthub.notion.site/LaTeX-1ca318bcf9ac81b3a2b8d8b5dd5bfbd7',
  COLLABORATIVE_EDIT:
    'https://opthub.notion.site/1ca318bcf9ac81f69e92f814a9c341e8',
  VISIBILITY_SELECT:
    'https://opthub.notion.site/1ca318bcf9ac81a6a91dd47f09a2698f',
  AD_REMOVE: 'https://opthub.notion.site/1ca318bcf9ac818c91c8daaf422da17a',
  PAST_INQUIRES: 'https://opthub.notion.site/1ca318bcf9ac813b8a32df5309872842',
}

export const TEAM_ACCOUNT_APPLICATION_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSdz2mdcG0MnW2Ol_kq-NTBWmtujbdVskZ3LRSmS1RLz4579zg/viewform?usp=sf_link'
